function setDiscountCode(discountCode) {
    var request = new XMLHttpRequest();
    request.open("GET", "/discount/" + discountCode);
    request.onreadystatechange = function() {
        if(this.readyState === 4 && this.status === 200) {
            console.log(discountCode + " Discount Added");
        }
    };

    request.send();
}

var urlParams = new URLSearchParams(window.location.search);
var myParam = urlParams.get('code');
var myAltParam = urlParams.get('promo');

if(myParam == "GSEXPO15") {
    //console.log("GSExpo 15% Discount Added");
    setDiscountCode("GSEXPO15");
}

if(myParam == "GSEXPO23") {
    //console.log("GSExpo 20% Discount Added");
    setDiscountCode("GSEXPO23");
}

if(myParam == "LASHCON") {
    //console.log("LASHCON 20% Discount Added");
    setDiscountCode("LASHCON");
}

if(myAltParam == "LIGHTS4ALL10" || myAltParam == "true") {
    //console.log("LIGHTS4ALL10 Discount Added");
    setDiscountCode("LIGHTS4ALL10");
}